export type FeedbackRequest = {
  numFicha: number;
  concluido: boolean
  comentario: string
  oidCliente: number;
}

export type CustomerFeedbackRequest = {
  numeroFicha: number;
  tipoAtendimento: TipoAtendimento
  respostas: RespostaFeedbackRequest[]
}


export type RespostaFeedbackRequest = {
  idPergunta: number;
  resposta?: RespostaCliente;
  motivos: number[];
}


export type FeedbackFilters = {
  numeroFicha: number;
  concluido?: boolean
  comentario?: string
  tipoAtendimento: TipoAtendimento
  respostas: RespostaFeedbackRequest[]
}

export enum TipoAtendimento {
  ATENDIMENTO = 'A',
  ATENDIMENTO_BASE = 'AB',
  FICHA = 'F',
  PA = 'P',
  CODIGO = '_',
}

export enum RespostaCliente {
  MUITO_SATISFEITO = 'MUITO_SATISFEITO',
  SATISFEITO = 'SATISFEITO',
  NEUTRO = 'NEUTRO',
  INSATISFEITO = 'INSATISFEITO',
  MUITO_INSATISFEITO = 'MUITO_INSATISFEITO',
}

export type PesquisaSatisfacao = {
  perguntas: PerguntaPesquisaSatisfacao[]
}

export type PerguntaPesquisaSatisfacao = {
  oid: number
  descricao: string,
  ordem: number
  motivosPerguntas: MotivosPerguntas[]
}

export type MotivosPerguntas = {
  oid: number
  descricao: string,
}
